import { apiFetch } from './client';

export const getPeople = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return apiFetch(`/api/people${qs ? '?' + qs : ''}`);
};
